import React, { Component, forwardRef } from 'react';
import { Button, Card, CardContent, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { MdDragIndicator, MdInfo } from 'react-icons/md';
import {
    MaterialReactTable,
} from 'material-react-table';
import { RxCaretRight } from "react-icons/rx";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import moment from 'moment';
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { IoIosArrowUp } from "react-icons/io";
import { isMobile } from 'react-device-detect';
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import MomentTz from 'moment-timezone'
import { FaGreaterThan } from "react-icons/fa";
import { getDateFormat } from '../../../../common/functions';
import { MdOutlineStart } from "react-icons/md";
import ApiRequestService from '../../../../components/ApiRequestService';

const statusArr = ["All", "Open", "Past", "Up Next"]

class AssignmentListWidget extends Component {

    constructor(props) {
        super(props);

        this.state = {
            assignments: [],
            filteredAssignments: [],
            loading: false,
            currentStatus: "",
            timeZone: null,
        }
    }

    componentDidMount() {

        if (this.props.course && this.props.course.course_id) {
            this.getAssignments()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.course?.course_id !== this.props.course?.course_id) {
            if (this.props.course && this.props.course.course_id) {
                this.getAssignments()
            }
        }
        if (prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.getAssignments()
        }
    }

    getBGStatusColor = (state) => {
        let colorClass = '';
        switch (state) {
            /*  case "Start":
                 colorClass = 'bg-scarlet'
                 break; */
            case "In Progress", "Start":
                colorClass = 'bg-white'
                break;
            case "Completed":
                colorClass = 'bg-success'
                break;
            case "Past":
                colorClass = 'bg-secondary'
                break;
            case "Up Next":
                colorClass = 'bg-blue'
                break;

            default:
                break;
        }


        return colorClass;
    }

    /* parseDate(dateString) {
        // Split the date string into components
        let parts = dateString.split('/');
        // Create a new Date object using the parts (year, month, day)
        // Note: Months in JavaScript Date objects are zero-based, so we subtract 1 from the month
        return new Date(parts[2], parts[1] - 1, parts[0]);
    } */

    parseDateTime(dateTimeString) {
        // Split the date and time parts
        let [datePart, timePart] = dateTimeString.split(' ');

        // Split the date part into components
        let dateParts = datePart.split('/');
        // Split the time part into components
        let timeParts = timePart.split(':');

        // Create a new Date object using the components
        // Note: Months in JavaScript Date objects are zero-based, so we subtract 1 from the month
        return new Date(
            dateParts[2],            // Year
            dateParts[1] - 1,        // Month (zero-based)
            dateParts[0],            // Day
            timeParts[0],            // Hours
            timeParts[1],            // Minutes
            timeParts[2]             // Seconds
        );
    }

    getAssignments = () => {
        this.setState({
            loading: true,
        })
        let response = ApiRequestService({
            method: "POST",
            url: "/getQuizStudentDashboard",
            data: {
                course_id: this.props.course.course_id,
                user_name: this.props.selectedStudentUserName,
            }
        });

        response.then(res => {
            console.debug("res.data.data", res.data.data)
            if (res.data && res.data.data && res.data.data.data) {
                let timeZone = res.data.data.time_zone
                this.setState({
                    timeZone: timeZone,
                })
                let newAssignments = res.data.data.data.filter(assign => assign.courseID !== -1);
                newAssignments = newAssignments.map((assign) => {

                    let today = new Date();
                    let start_date = MomentTz.tz(assign.start_date + " " + assign.start_time, 'DD/MM/YYYY hh:mm:ss', timeZone).toDate();
                    let end_date = MomentTz.tz(assign.end_date + " " + assign.end_time, 'DD/MM/YYYY hh:mm:ss', timeZone).toDate();

                    let state = "";
                    if (assign.is_finish === 1) {
                        state = "Completed";
                    } else if (today.getTime() < start_date.getTime()) { // Up next
                        state = "Up Next"
                    } else if (today.getTime() > start_date.getTime() && today.getTime() < end_date.getTime()) { // Past/Closed
                        state = "Start"
                        if (assign.is_finish === 0 && assign.finalscore_start_time?.length) {
                            state = "In Progress"
                        }
                    } else {
                        state = "Past"
                    }
                    return {
                        ...assign,
                        state: state,
                        startDateAndTime: start_date,
                        endDateAndTime: end_date,
                    }
                });
                console.debug("newAssignments", newAssignments)
                this.setState({
                    assignments: newAssignments
                })
            } else {
                this.setState({
                    assignments: [],
                })
            }
        }).catch(err => {
            console.debug("err", err)
        }).finally(() => {
            this.setState({
                loading: false,
                currentStatus: "All",
            })
            this.handleFilterAssignmentsBy("All");
        })
    }

    handleFilterAssignmentsBy = (status) => {
        const stateOrders = {
            'In Progress': 1,
            'Start': 2,
            'Up Next': 3,
            'Past': 4
        };

        let filteredAssignments = this.state.assignments;

        if (status !== "All") {
            let statuses = [status]
            if (status === "Open") {
                statuses = ["Start", "In Progress"];
            }
            filteredAssignments = this.state.assignments.filter(assign => statuses.includes(assign.state));
        } else {
            // order by open, up next and the close
            filteredAssignments = this.state.assignments.sort((a, b) => {
                return stateOrders[a.state] - stateOrders[b.state];
            });
        }

        filteredAssignments = filteredAssignments.sort((a, b) => {
            if (a.state === "Start" || a.state === "In Progress") {
                return a.endDateAndTime - b.endDateAndTime;
            }
            return false
        })

        console.debug("filteredAssignments>>", filteredAssignments)
        this.setState({
            filteredAssignments,
        })
    }

    handleTakeQuizURL = (assignment) => {

        // TODO: Probably will change the takequiz name
        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${assignment.quizType || assignment.quiz_type}&course_name=${assignment.courseName || assignment.course_name}`

        this.props.handleRoute(url)
    }

    handleStatusFilterClick = (index) => {
        let status = statusArr[index];
        this.setState({
            currentStatus: status
        })
        this.handleFilterAssignmentsBy(status);
    }


    isListHasAnyPracticeAssignment = () => {
        let value = true;

        if (this.props.course) {
            if (this.props.course.enable_practice_and_performance === 0) {
                return false
            }
        }

        return value;
    }

    render() {

        const { assignments, filteredAssignments, loading, timeZone } = this.state;

        const columns = [
            {
                accessorKey: 'quiz_name',
                header: 'Quiz Name',
                size: 100,
            },
            {
                accessorKey: 'completion_percentage',
                header: 'Score',
                size: 80,
                accessorFn: (assignment) => {
                    if (assignment.state === 'Start' || assignment.state === 'Up Next') {
                        return "N/A"
                    }
                    if (assignment.fullScoreIfAttempted === 1) {
                        if (assignment.is_finish === 1) return "100%"
                        return "0%"
                    }

                    return Math.round(parseFloat(assignment.completion_percentage)) + "%";
                },
            },
            /* {
                accessorKey: 'quiz_type',
                header: 'Type',
                size: 10,
                accessorFn: (assignment) => {
                    if (assignment.quiz_type === 0) {
                        return "Mastery"
                    }
                    return "Test"
                },
            }, */
            {
                accessorKey: 'start_date',
                header: 'Start Date',
                size: 80,
                accessorFn: (assignment) => {
                    return getDateFormat(assignment.start_date, timeZone)
                },
            },
            {
                accessorKey: 'end_date',
                header: 'End Date',
                size: 80,
                accessorFn: (assignment) => {
                    return getDateFormat(assignment.end_date, timeZone)
                },
            },
            {
                accessorKey: 'state',
                header: 'Status',
                enableSorting: false,
                size: 2,

                accessorFn: (assignment) => {
                    // console.debug("assignmentassignment", assignment)

                    let isResume = false;
                    let score = assignment.scores?.find(score => score.practice_number === assignment.practice_count);
                    if (score && score.is_finish === 0) {
                        isResume = true;
                    }

                    let canPratice = assignment.is_finish && assignment.allow_practice && this.props.course && this.props.course.enable_practice_and_performance !== 0

                    return (
                        <div className='d-flex justify-content-center align-items-center' style={{ gap: "12px" }}>
                            <div style={{
                                width: '26px',
                                height: '26px',
                                borderRadius: '13px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: (assignment.state === "Start" || assignment.state === "In Progress") ? 'pointer' : 'default'
                            }} className={this.getBGStatusColor(assignment.state)}
                            >
                                {/*  {(assignment.state === "Start") ?
                                    <RxCaretRight fontSize={28} color='white' fontWeight={'500'} />
                                    : null} */}
                                {assignment.state === "In Progress" || assignment.state === "Start" ?
                                    <div style={{
                                        border: '1px solid #bb0000',
                                        borderRadius: '50%',
                                        width: '26px',
                                        height: '26px',
                                    }} className='d-flex justify-content-center align-items-center'>
                                        <RxCaretRight fontSize={28} color='#bb0000' fontWeight={'500'} />
                                    </div>
                                    : null}
                                {(assignment.state === "Completed") ?
                                    <FaCheck fontSize={16} color='white' />
                                    : null}
                                {(assignment.state === "Past") ?
                                    <IoClose fontSize={16} color='white' />
                                    : null}
                                {(assignment.state === "Up Next") ?
                                    <IoIosArrowUp fontSize={16} color='white' />
                                    : null}
                            </div>
                            {/* {canPratice ?
                                <div className='ml-3'>
                                    <Tooltip arrow placement='top' title={
                                        <Typography color='#fff'>
                                            Additional practice: {assignment.practice_count - 1}
                                        </Typography>
                                    }>
                                        <Button
                                            variant='contained'
                                            size='small' onClick={() => {
                                                console.debug("assignment", assignment)
                                                this.handleTakeQuizURL(assignment)
                                            }}
                                        >
                                            {isResume ? "Resume Practice" : "Practice Again"}
                                        </Button>
                                    </Tooltip>
                                </div>
                                : null} */}
                        </div>
                    )
                },
            },
            {
                accessorKey: 'practice',
                header: <div>
                    <span>Extra Practice</span>
                    <Tooltip title={
                        <Typography color='#fff'>
                            You can practice assignment here (or) create your own practice set from "Performance Analytics" or "Build your own Practice Sets" cards.
                        </Typography>
                    } placement='top' arrow>
                        <span className='ml-1'><MdInfo color='#646a6e' /></span>
                    </Tooltip>
                </div>,
                size: 140,
                enableHiding: true,
                accessorFn: (assignment) => {
                    if (assignment.is_finish && assignment.quiz_type === 0 && this.props.course && this.props.course.enable_practice_and_performance !== 0) {

                        let isResume = false;
                        let score = assignment.scores?.find(score => score.practice_number === assignment.practice_count);
                        if (score && score.is_finish === 0) {
                            isResume = true;
                        }

                        return (
                            <div>
                                <Tooltip placement='top' title={`Number of times practiced: ${assignment.practice_count - 1}`}>
                                    <Button variant='contained' size='small' 
                                    disabled={this.props.selectedStudentUserName}
                                    onClick={() => {
                                        this.handleTakeQuizURL(assignment)
                                    }}>
                                        {isResume ? "Resume Practice" : "Practice Again"}
                                    </Button>
                                </Tooltip>
                            </div>
                        )
                    } else {
                        return ""
                    }
                },
            },
        ];

        return (
            <Card className='h-100 w-100 position-relative' sx={{ boxShadow: 3, borderRadius: 2 }}>
                {loading ? null :
                    <div className='d-flex justify-content-between align-items-end p-3' style={{
                        alignItems: 'flex-start'
                    }}>
                        <div className='d-flex' style={{
                            flexDirection: isMobile ? 'column' : 'row'
                        }}>
                            <Typography fontSize={18} fontWeight={'500'} className='mr-2'>
                                List of All Assignments {loading ? '' : <span>[{assignments?.length}]</span>}
                            </Typography>
                            <div className='d-flex align-items-center' style={{ gap: '3px' }}>
                                {/* <Typography fontSize={14} fontWeight={500}>
                                    Status :
                                </Typography> */}
                                {statusArr.map((status, index) => {
                                    return <Chip
                                        clickable
                                        // component="a"
                                        onClick={() => this.handleStatusFilterClick(index)}
                                        key={index}
                                        style={{
                                            width: '70px',
                                            background: status === this.state.currentStatus ? '#bb0000' : 'inherit',

                                        }}
                                        label={
                                            <Typography style={{
                                                color: status === this.state.currentStatus ? '#fff' : 'inherit',
                                            }}
                                                fontSize={12}
                                            >
                                                {status}
                                            </Typography>
                                        }
                                        variant={status === this.state.currentStatus ? "filled" : "outlined"}
                                    />
                                })}
                            </div>
                        </div>
                        <div className='cursor-pointer drag-handle' style={{ cursor: 'move' }}>
                            <MdDragIndicator fontSize={24} />
                        </div>
                    </div>
                }
                <CardContent className='h-100 w-100 position-relative'>
                    {loading ? (
                        <div className='h-100 mt-5 position-relative'>
                            <div className='w-100 position-relative'>
                                <Skeleton className='my-2' count={5} />
                            </div>
                        </div>
                    ) : (
                        <div className='list-assignment-card'>
                            <div className='list-assignment-card-table'>
                                <MaterialReactTable
                                    className=''
                                    columns={columns}
                                    data={filteredAssignments}
                                    enableTopToolbar={false}
                                    enablePagination={false}
                                    enableStickyHeader={true}
                                    enableColumnActions={false}
                                    initialState={{ columnVisibility: { practice: this.isListHasAnyPracticeAssignment() } }}
                                    muiTableBodyRowProps={({ row }) => ({
                                        onClick: (_) => {
                                            let index = parseInt(row.id);
                                            let assignment = filteredAssignments[index];
                                            if (assignment.state === "Start" || assignment.state === "In Progress") {
                                                if (this.props.selectedStudentUserName) {
                                                    return;   
                                                }
                                                this.handleTakeQuizURL(assignment)
                                            }
                                        },
                                        sx: {
                                            cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                        },
                                    })}
                                    icons={{
                                        /* ArrowUpwardIcon: (props) =>  <FaSortUp {...props} />,
                                        ArrowDownwardIcon: (props) =>  <FaSortDown {...props} />,
                                        SortIcon: forwardRef((props, ref) => (<FaSort {...props} ref={ref}/>)), */
                                    }}
                                    renderEmptyRowsFallback={() => {
                                        return (
                                            <div className='text-center h-100 w-100 d-flex justify-content-center align-items-center pt-4'>
                                                <br /><br /><br /><br />
                                                <br /><br /><br /><br />
                                                <br /><br /><br />
                                                <Typography color='primary' fontWeight={'500'} variant='h5'>
                                                    No Assignments found
                                                </Typography>
                                                {/* <Typography className='mt-2'>
                                                <em>You could create practice assignments to improve your accuracy and time.</em>
                                            </Typography> */}
                                            </div>
                                        )
                                    }}
                                    muiTablePaperProps={
                                        {
                                            elevation: 0,
                                            sx: {
                                                padding: 0,
                                                margin: 0,
                                                height: '100%',
                                                position: 'relative'
                                            }
                                        }
                                    }
                                    muiTableHeadCellProps={{
                                        sx: {
                                            color: '#bb0000',
                                            fontWeight: '600',
                                            fontSize: "14px"
                                        }
                                    }}
                                    muiTableContainerProps={{
                                        sx: {
                                            height: '100%',
                                            position: 'relative'
                                        }
                                    }}

                                />
                            </div>
                            <div className='list-widget-status-container' style={{ gap: '1rem' }}>
                                {/* <div>
                                    <div style={{
                                        width: "26px",
                                        height: "26px",
                                        background: "#ba0d2f",
                                        borderRadius: "50%",

                                    }} className='mr-1'>
                                        <RxCaretRight color='#fff' fontSize={22} />
                                    </div>
                                    Open
                                </div> */}
                                <div>
                                    <div style={{
                                        width: "26px",
                                        height: "26px",
                                        background: "#fff",
                                        border: '1px solid #ba0d2f',
                                        borderRadius: "50%",
                                    }} className='mr-1'>
                                        <RxCaretRight color='#ba0d2f' fontSize={22} />
                                    </div>
                                    Open/In Progress
                                </div>
                                <div>
                                    <span className='status-circle bg-success fontClass-10 d-flex justify-content-center text-white align-items-center'>
                                        <FaCheck fontSize={16} color='white' />
                                    </span>
                                    Completed
                                </div>
                                <div>
                                    <span className='status-circle bg-blue d-flex justify-content-center text-white align-items-center' >
                                        <IoIosArrowUp fontSize={16} color='white' />
                                    </span>
                                    Scheduled
                                </div>
                                <div>
                                    <span className='status-circle bg-secondary d-flex justify-content-center text-white align-items-center fontClass-12'>
                                        <IoClose fontSize={16} color='white' />
                                    </span>
                                    Past
                                </div>
                            </div>
                        </div>
                    )}

                </CardContent>
            </Card>
        )
    }
}

export default AssignmentListWidget;
